import { css } from '@emotion/core'

import { Color } from '../../../enums/color'
import { Variant } from '../types'

export const getFocusedStyle = (variant?: Variant) => css`
  outline: 2px solid ${Color.Black};
  outline-offset: 2px;
  box-shadow: ${variant === 'outlined' ? `inset 0 0 0 1px ${Color.Grey200}` : 'none'};
`
